// トップスライダーの起動 // Launch the top slider

const swiper = new Swiper(".top-slider", {
  loop: true,
  slidesPerView: 'auto', 
  speed: 6000, 
  spaceBetween: 16,
  allowTouchMove: false, 
  autoplay: {
    delay: 0, 
  },
});